export default {
  title: "Telefoonnummers",

  noItems: {
    title: "Geen telefoonnummers",
    text: "Klik om een telefoonnummer toe te voegen",
  },

  input: {
    title: "Telefoonnummer {{action}}",
    type: {
      label: "Type",
    },
    phoneNumber: {
      label: "Telefoonnummer",
    },
  },

}
